module.exports = __webpack_public_path__ + "img/RockyLinux.1020523.svg";